import { Box, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { UserManageable } from "common/store/user/types";
import React from "react";
import { useTranslation } from "react-i18next";

interface WalletSuccessfullyCreatedSubformProps {
  user: UserManageable;
}

export const WalletSuccessfullyCreatedSubform = (props: WalletSuccessfullyCreatedSubformProps) => {
  // Hooks
  const { t } = useTranslation();

  return (
    <Box className="grid-container">
      <CheckCircleIcon className="icon--big" />

      <Typography className="title--centered--isolated">{t("Congratulations")}</Typography>

      <Typography className="subtitle--centered">
        {t("Token wallet was successfully created")}
      </Typography>

      <Typography className="subtitle--centered subtitle--bold">
        {t("Your token wallet’s public address")} {props.user.wallet?.publicKey}
      </Typography>
    </Box>
  );
};
